<div class="iframe-container" [innerHtml]="html"></div>
